module.exports = __webpack_public_path__ + "static/media/logo.a08d3329.png";